export enum ChannelNameValidationRules {
	MaxLength = 31,
	Regex = '[^.=@]*'
}
